import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Box } from '@primer/react';
import ComponentLayout from '~/src/layouts/component-layout';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p><img parentName="p" {...{
        "src": "https://github.com/user-attachments/assets/b0c1f1cb-0446-4767-9d19-c15b87b53fda",
        "alt": "Interface showing selectable options for events, users, languages, and projects. Events include Announcements, Releases, Sponsors, Stars, and Repositories. User selection shows profiles such as six7, maximedegrve, TheDamianHdez. Language options include C, C#, C++, CoffeeScript, CSS, Dart, DM, Elixir. Project selection shows Proxima issues from multiple tests and other repositories."
      }}></img></p>
    <h2>{`Options`}</h2>
    <h3>{`Single Selection`}</h3>
    <p><img parentName="p" {...{
        "src": "https://github.com/user-attachments/assets/673b6671-47a8-46ed-9200-dc2a1710f374",
        "alt": "Select panel titled Change author with a search bar and a list of names including Jan Six, Maxime De Greve, Damian Hernandez, Joyce Lau, Lee Reilly, Gavin Nelson, Amy Burns, Lerè, Cole Bemis, Lukas Oppermann, and Sophie Shepherd."
      }}></img></p>
    <p>{`For single-item selection, the panel closes immediately upon selection. The selected item is indicated by a checkmark. Set the `}<inlineCode parentName="p">{`selectionVariant`}</inlineCode>{` prop on `}<inlineCode parentName="p">{`ActionList`}</inlineCode>{` to `}<inlineCode parentName="p">{`single`}</inlineCode>{`.`}</p>
    <h3>{`Multi Selection`}</h3>
    <p><img parentName="p" {...{
        "src": "https://github.com/user-attachments/assets/bcf32736-35c9-42c2-837a-6a62767bbcec",
        "alt": "Set labels select panel showing various labels including a11y design (checked), a11y sign-off, accessibility, area: accessibility, at risk, and blocked with a search bar at the top.'"
      }}></img></p>
    <p>{`For multi-item selection, the panel remains open after each selection, allowing users to choose multiple items before closing the panel to confirm their choices. Selections are visually indicated by faux checkboxes. Set the `}<inlineCode parentName="p">{`selectionVariant`}</inlineCode>{` prop on `}<inlineCode parentName="p">{`ActionList`}</inlineCode>{` to `}<inlineCode parentName="p">{`multiple`}</inlineCode>{`.`}</p>
    <h3>{`Groups`}</h3>
    <p>{`Items can be grouped to provide additional context or to visually separate them. Each group can have a title for better organization.`}</p>
    <h3>{`Footer`}</h3>
    <p><img parentName="p" {...{
        "src": "https://github.com/user-attachments/assets/7c1c4ad0-5fae-45fb-b932-006d3dd1aed4",
        "alt": "Select panel showing a list of users with checkboxes and names including Gavin Nelson, Amy Burns, Léré, Cole Bemis, Lukas Oppermann, and Sophie Shepherd. Below is an 'Add a new user' button. Adjacent is a labels select panel section with checkboxes for labels 'accessibility', 'at risk', and 'blocked', along with a 'Manage labels' link in the footer."
      }}></img></p>
    <p>{`An optional footer at the bottom can include a link or button for additional actions.`}</p>
    <h3>{`Opening`}</h3>
    <p><img parentName="p" {...{
        "src": "https://github.com/user-attachments/assets/90c9ffa3-302c-4a59-b8d3-5f8f747489bd",
        "alt": "Three buttons displayed: a gear icon button labeled 'Icon button', a dropdown button labeled 'Assignees: 2 people' with 'Button (internal label)' below, and another dropdown button labeled 'Assignees' with '2 people' as value and 'Button (external label)' below."
      }}></img></p>
    <p>{`Select panels can be activated via a semantic button, which can be either a regular button or an icon button. If the button represents the current selection, it must have an associated label, either internally (within the button) or externally (adjacent to the button).`}</p>
    <h2>{`Anatomy`}</h2>
    <p><img parentName="p" {...{
        "src": "https://github.com/user-attachments/assets/4eaaba98-1fa7-4d7a-a243-0007cd4cc1b4",
        "alt": "Label selection select panel with the options a11y design, a11y sign-off, accessibility, area: accessibility, at risk, and blocked, each with corresponding checkboxes. The header, list, input and footer is annotated."
      }}></img></p>
    <p>{`The select panel consists of three main areas: a header, a scrollable list that can be filtered, and an optional footer:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Header`}</strong>{`: Includes a title and a close button.`}</li>
      <li parentName="ul"><strong parentName="li">{`Input and List (scrollable)`}</strong>{`: The scrollable list contains action list items, which can be either single or multi-select options. The input field allows users to quickly filter the list.`}</li>
      <li parentName="ul"><strong parentName="li">{`Footer`}</strong>{`: Can contain an actionable button.`}</li>
    </ul>
    <h2>{`Best Practices`}</h2>
    <h3>{`Empty State`}</h3>
    <p><img parentName="p" {...{
        "src": "https://github.com/user-attachments/assets/7e4568fa-60be-44a3-b968-f2f0b6dcbb94",
        "alt": "Screen showing two search panels side by side. The left panel titled 'Set project' with a search bar displaying 'Search' and a message below stating 'You haven't created any projects yet' followed by 'Start your first project to organise your issues.' The right panel titled 'Filter by language' with a search bar containing 'CSA' and a message below stating 'No language found for CSA' followed by 'Adjust your search term to find other languages.' Both panels have no items or matches"
      }}></img></p>
    <p>{`When no results are available, offer users an explanation instead of leaving a blank space. There can be various reasons for the absence of results. It could be due to the search or filter input value not matching any available data, or it could be because the user has yet to generate any data to display.`}</p>
    <h3>{`Loading`}</h3>
    <p><img parentName="p" {...{
        "src": "https://github.com/user-attachments/assets/bcd1e1d7-ad71-4820-ba8f-487a0462137f",
        "alt": "Three stages of an 'Assign people' select panel. The first stage shows an empty search bar with a spinner and 'Fetching people...' text. The second stage displays the same search bar with skeleton loaders. The third stage shows a search for 'six' with a list of users, including avatars and names such as 'Jan Six', 'Manuel Muñoz Solera', and 'Vinicius Depizzol'."
      }}></img></p>
    <p>{`Provide visual cues to users when processes may take longer than expected. Use loading states at different stages to communicate effectively.`}</p>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Initial`}</strong>{`: Use when retrieving initial data to prevent users from seeing an empty list.`}</li>
      <li parentName="ol"><strong parentName="li">{`Initial (skeleton)`}</strong>{`: Use a skeleton loader when retrieving initial data to prevent users from seeing an empty list.`}</li>
      <li parentName="ol"><strong parentName="li">{`Searching/Filtering`}</strong>{`: When users search for new items, maintain their current selections and use a minimal loading state to indicate ongoing activity.`}</li>
    </ol>
    <h3>{`Current Selection`}</h3>
    <p><img parentName="p" {...{
        "src": "https://github.com/user-attachments/assets/12f4dd86-ec9b-4a9e-8246-e92bed87fa00",
        "alt": "Three dropdown menus labeled Filter by language. The first menu on the left, labeled Default, shows the default state with C (first) and DM (fourth) selected. The middle menu, labeled After making a selection, shows C (first), C# (second), and DM (fourth) selected. The right menu, labeled When filtering, shows filtering with the search term C, displaying C (first) and C# (second) selected."
      }}></img></p>
    <p>{`To make the current selection clear, display the selected items at the beginning of the list. This behavior should occur when opening the select panel, after users clear the input or when they change the filter value. Avoid reordering items after selection to prevent disorientation.`}</p>
    <h3>{`Error/Warning Handling`}</h3>
    <p><img parentName="p" {...{
        "src": "https://github.com/user-attachments/assets/272174b3-7f32-45cc-8ad1-9b063f8d98a4",
        "alt": "Two side-by-side author select panels with titles \"Default values fail to load\" (left) and \"Search fails\" (right). Left dialog shows \"We couldn’t load the authors\" with a red warning icon, search bar, placeholder text: \"Try again or if the problem persists contact support.\" Right dialog shows search for \"max,\" listing authors including \"six7,\" \"maximedegreve,\" and others, but an error states \"We couldn’t load the authors\" with a red warning icon below the title."
      }}></img></p>
    <p>{`When things don't work as expected, or users need to be informed about important issues, we handle these scenarios appropriately. If default values fail to load, we display an error placeholder to inform the user. When users search for new values and the search fails, we display an error message above the input.`}</p>
    <h2>{`Behavior`}</h2>
    <p>{`The select panel opens when the trigger button is activated by a click, `}<inlineCode parentName="p">{`Enter`}</inlineCode>{`, or `}<inlineCode parentName="p">{`Space`}</inlineCode>{`.`}</p>
    <h3>{`Interactions`}</h3>
    <p>{`Focus is initially placed on the input field and the first item in the list, which are connected as one focusable entity. Users can type to filter the list or navigate using `}<inlineCode parentName="p">{`ArrowUp`}</inlineCode>{` and `}<inlineCode parentName="p">{`ArrowDown`}</inlineCode>{`.`}</p>
    <h3>{`Apply Changes`}</h3>
    <p>{`Closing the select panel applies all changes. It can be closed by clicking the trigger button again, the close button, clicking outside the panel, or pressing the `}<inlineCode parentName="p">{`Esc`}</inlineCode>{` key.`}</p>
    <h3>{`Keyboard Navigation`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Key`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Tab`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Move focus forward between interactive controls and widgets within the dialog.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Shift + Tab`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Move focus backward between interactive controls and widgets within the dialog.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Enter`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Select items in the list or activate buttons or links within the select panel.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Space`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Type a space in the input or activate buttons or links within the select panel.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ArrowDown`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Navigate forward through items in the list. If focus is on the last item, `}<inlineCode parentName="td">{`ArrowDown`}</inlineCode>{` moves focus to the first item.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ArrowUp`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Navigate backward through items in the list. If focus is on the first item, `}<inlineCode parentName="td">{`ArrowUp`}</inlineCode>{` moves focus to the last item.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Home`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Move focus to the first item in the list.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`PageUp`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Move focus to the first item in the list.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`End`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Move focus to the last item in the list.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`PageDown`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Move focus to the last item in the list.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Esc`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Apply changes and close the select panel.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      